<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section-no" id="tocsec-1"><a id="page_16"><span class="pt">SECTION A</span></a></h1><a id="page_16">
<h1 class="sec-title"><strong>Questions Related to the Quest for the Historical Jesus</strong></h1>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 010_Section1A.vue?5ab71471